// JS FRONT OFFICE

import './_tools'

const moveElementOnResponsive = (breakpoint, elementToMove, positionBeforeMove, targetAfterMove ) => {
    $(window).resize(function() {
        if($(window).width() < breakpoint) {
            $(elementToMove).insertAfter(targetAfterMove);
        }
    
        else {
            $(elementToMove).insertAfter(positionBeforeMove);
        }
    });
    
    if($(window).width() < breakpoint) {
        $(elementToMove).insertAfter(targetAfterMove);
    }
    
    else {
        $(elementToMove).insertAfter(positionBeforeMove);
    }
}

moveElementOnResponsive(500, '.btn-contact', '.main-nav', '.last-link');

$('.main-nav a').on('click', function() {
    $('.menu').removeClass('showing-nav');
    $('.toggle-nav').removeClass('menu-open');
});

$(window).on('scroll', function() {
    if($(window).scrollTop() > 10) {
        $('.logo').addClass('small');
    } else {
        $('.logo').removeClass('small');
    }
});